import { view } from '@/.storybook/storybook.requires';
import { MmkvStorage } from '@/hooks/useUnencryptedStorage';

const StorybookUIRoot = view.getStorybookUI({
  storage: {
    getItem: async (key: string) => {
      const value = MmkvStorage.getString(key);
      return value || null;
    },
    setItem: async (key: string, value: string) => {
      MmkvStorage.set(key, value);
    },
  },

});

export default StorybookUIRoot;
